import config from '@vht/react-components/config';

config.platformManagement = config.platformManagement || {};
config.platformManagement.appId = 'platform-management';
config.platformManagement.apiUrl = process.env.REACT_APP_PLATFORM_MANAGEMENT_API_URL || '/api/platform-management';
config.platformManagement.uiUrl = process.env.REACT_APP_PLATFORM_MANAGEMENT_UI_URL || '';
config.platformManagement.termsOfServiceUrl = 'https://www.vhtcx.com/about/cloud-tos/';

config.continuity = config.continuity || {};
config.continuity.appId = 'continuity';

config.conversationBridge = config.conversationBridge || {};
config.conversationBridge.appId = 'conversation-bridge';

export default config;
